






























import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isEqual } from 'lodash'

@Component
export default class InputSimpleArray extends Vue {
    @Prop({ type: String }) readonly vid!: string
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: null }) readonly placeholder!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string[]
    internalValue: string[] = null
    addableEmail: string = ''
    focus: boolean = false

    created() {
        this.onExternalChange()
    }

    transformInput(value: string[]) {
        return value
    }

    transformOutput(value: string[]) {
        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)

        if (this.internalValue === null) {
            this.internalValue = []
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        const value = this.transformOutput(this.internalValue)

        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onInput(): void {
        this.$emit('input', this.internalValue)
    }

    onFocus(): void {
        this.focus = true
    }

    onBlur(): void {
        this.focus = false
    }

    removeItem(index): void {
        this.internalValue.splice(index, 1)
    }

    addItem(): void {
        if (!this.addableEmail) {
            return
        }

        this.internalValue.push(this.addableEmail)
        this.addableEmail = null
    }

    get componentClass(): object {
        return {
            'input-simple-array': true,
            'bd-round-outline': true,
            'input-simple-array--focussed': this.focus,
            'input-simple-array--disabled': this.disabled,
        }
    }
}
